import "core-js/modules/es.array.concat.js";
// Constants
import constants from "./constants/media-queries.constants";
import mediaQueriesConstants from "../../constants/breakpoints";
var mobileMediaQuery = "".concat(constants.MEDIA_QUERY_LABEL, " (max-width: ").concat(mediaQueriesConstants.MOBILE - 1, "px)");
var tabletMediaQuery = "".concat(constants.MEDIA_QUERY_LABEL, " (min-width: ").concat(mediaQueriesConstants.MOBILE, "px) and (max-width: ").concat(mediaQueriesConstants.TABLET, "px)");
var desktopMediaQuery = "".concat(constants.MEDIA_QUERY_LABEL, " (min-width: ").concat(mediaQueriesConstants.TABLET + 1, "px) and (max-width: ").concat(mediaQueriesConstants.DESKTOP, "px)");
var wideDesktopMediaQuery = "".concat(constants.MEDIA_QUERY_LABEL, " (min-width: ").concat(mediaQueriesConstants.DESKTOP + 1, "px) and (max-width: ").concat(mediaQueriesConstants.WIDE_DESKTOP, "px)");
var ultraWideDesktopMediaQuery = "".concat(constants.MEDIA_QUERY_LABEL, " (min-width: ").concat(mediaQueriesConstants.WIDE_DESKTOP + 1, "px)");
var mobileTabletAndDesktopMediaQuery = "".concat(constants.MEDIA_QUERY_LABEL, " (max-width: ").concat(mediaQueriesConstants.DESKTOP, "px)");
var mobileAndTabletMediaQuery = "".concat(constants.MEDIA_QUERY_LABEL, " (max-width: ").concat(mediaQueriesConstants.TABLET, "px)");
export default {
  desktopMediaQuery: desktopMediaQuery,
  mobileTabletAndDesktopMediaQuery: mobileTabletAndDesktopMediaQuery,
  mobileAndTabletMediaQuery: mobileAndTabletMediaQuery,
  mobileMediaQuery: mobileMediaQuery,
  tabletMediaQuery: tabletMediaQuery,
  ultraWideDesktopMediaQuery: ultraWideDesktopMediaQuery,
  wideDesktopMediaQuery: wideDesktopMediaQuery
};